export default "__VITE_PUBLIC_ASSET__65e515ca__"